import { useState } from "react";
import { Search, MapPin, ArrowRight } from "lucide-react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";

const CATEGORIAS = [
  "Obstetras", "Pediatras", "Clínicas de fertilidade", "Doulas",
  "Consultoras de amamentação", "Psicólogos perinatais", "Nutricionistas",
  "Fisioterapeutas pélvicos", "Cursos de gestante", "Fotografia",
  "Maternidades", "Clínicas de vacinação",
];

const selectClass =
  "w-full bg-white border border-maternnia-nevoa rounded-xl px-4 py-3 text-sm text-maternnia-charcoal focus:outline-none focus:ring-2 focus:ring-maternnia-pink/30 focus:border-maternnia-pink transition";

const Profissionais = () => {
  const [termo, setTermo] = useState("");
  const navigate = useNavigate();

  const handleBuscar = (e) => {
    e.preventDefault();
    navigate("/profissionais");
  };

  return (
    <section id="profissionais" data-testid="profissionais-section" className="bg-maternnia-nevoa/40 py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <motion.div
          className="max-w-2xl mb-12"
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
        >
          <span className="text-sm font-semibold tracking-widest text-maternnia-pink uppercase">Profissionais</span>
          <h2 className="font-serif text-4xl md:text-5xl tracking-tight text-maternnia-charcoal mt-4 font-medium">
            Encontre profissionais e serviços para cada necessidade.
          </h2>
        </motion.div>

        {/* Search bar */}
        <motion.form
          onSubmit={handleBuscar}
          data-testid="busca-profissionais-form"
          className="bg-white rounded-3xl p-6 md:p-8 shadow-[0_16px_44px_rgba(43,37,38,0.08)] border border-white"
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
        >
          <div className="relative mb-4">
            <Search size={18} className="absolute left-4 top-1/2 -translate-y-1/2 text-maternnia-taupe" />
            <input
              data-testid="busca-input"
              type="text"
              value={termo}
              onChange={(e) => setTermo(e.target.value)}
              placeholder="Busque por nome, especialidade ou serviço..."
              className="w-full bg-maternnia-porcelana/60 border border-maternnia-nevoa rounded-xl pl-12 pr-4 py-3.5 text-sm text-maternnia-charcoal placeholder:text-maternnia-taupe/70 focus:outline-none focus:ring-2 focus:ring-maternnia-pink/30 focus:border-maternnia-pink transition"
            />
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
            <select data-testid="busca-etapa" className={selectClass} defaultValue="">
              <option value="" disabled>Etapa</option>
              <option>Planejamento</option>
              <option>Gestação</option>
              <option>Parto</option>
              <option>Pós-parto</option>
            </select>
            <select data-testid="busca-categoria" className={selectClass} defaultValue="">
              <option value="" disabled>Categoria</option>
              {CATEGORIAS.map((c) => <option key={c}>{c}</option>)}
            </select>
            <div className="relative">
              <MapPin size={16} className="absolute left-3.5 top-1/2 -translate-y-1/2 text-maternnia-taupe" />
              <input data-testid="busca-local" type="text" placeholder="Localização" className={`${selectClass} pl-10`} />
            </div>
            <select data-testid="busca-modalidade" className={selectClass} defaultValue="">
              <option value="" disabled>Online ou presencial</option>
              <option>Online</option>
              <option>Presencial</option>
            </select>
          </div>
          <div className="mt-5 flex flex-col sm:flex-row gap-3">
            <button
              type="submit"
              data-testid="busca-submit"
              className="group inline-flex items-center justify-center gap-2 bg-maternnia-pink text-white hover:bg-maternnia-pinkHover rounded-full px-7 py-3.5 text-sm font-medium transition-all duration-300 hover:scale-[1.02] active:scale-[0.98]"
            >
              <Search size={17} /> Buscar
            </button>
          </div>
        </motion.form>

        {/* Featured categories */}
        <div className="mt-10">
          <p className="text-sm font-medium text-maternnia-taupe mb-4">Categorias em destaque</p>
          <div className="flex flex-wrap gap-3">
            {CATEGORIAS.map((c) => (
              <button
                key={c}
                data-testid={`categoria-${c}`}
                onClick={() => navigate("/profissionais")}
                className="text-sm font-medium text-maternnia-charcoal bg-white border border-maternnia-nevoa rounded-full px-5 py-2.5 hover:bg-maternnia-eucalipto hover:text-white hover:border-maternnia-eucalipto transition-all duration-300"
              >
                {c}
              </button>
            ))}
          </div>
        </div>

        <div className="mt-12">
          <button
            data-testid="explorar-profissionais-cta"
            onClick={() => navigate("/profissionais")}
            className="group inline-flex items-center gap-2 text-maternnia-eucalipto hover:text-maternnia-floresta font-semibold transition-colors"
          >
            Explorar todos os profissionais
            <ArrowRight size={18} className="transition-transform duration-300 group-hover:translate-x-1.5" />
          </button>
        </div>
      </div>
    </section>
  );
};

export default Profissionais;
